import { Container } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { logger } from '@orbital/slot-lib';

class Reel extends Container {
	static FINISHED = 'finished';
	static STOP_SIMPLE = 'stop_simple';
	static STOP_BAIT = 'stop_bait';
	static STOP_FAST = 'stop_fast';
	static ScatterCode = 10;
	holder = null;
	items = null;
	rotateItems = null;
	rotateBaitItems = null;
	stopItems = null;
	id = null;
	config = null;
	finished = false;
	maskGraphics = null;
	reelHandler = null;
	stopMode = '';
	nextItems = null;

	constructor(_id, _cfg, _reelHandler) {
		super();
		// console.log("Reel created");

		this.id = _id;
		this.config = _cfg;
		this.stopMode = Reel.STOP_SIMPLE;
		this.reelHandler = _reelHandler;
		this.holder = new Container();
		this.addChild(this.holder);
		this.items = [];
		this.rotateItems = [];
		this.rotateBaitItems = [];
		this.stopItems = [];
		this.currentFloor = 0;
		this.sortableChildren = true;
		for (let i = 0; i < this.config.height; i++) {
			let randomItem =
				this.config.icons[
					Math.floor(Math.random() * (this.config.icons.length - 1))
				];
			// let item = new randomItem.IconClass(randomItem, false, true);
			let item = new randomItem.IconClass(randomItem, false, true, false, {
				col: this.id,
				row: i
			});
			this.items.push(item);

			item.y = this.config.iconHeight * i;
			this.holder.addChildAt(item, 0);
		}

		for (let i = 0; i < 30; i++) {
			let randomItem =
				this.config.icons[
					Math.floor(Math.random() * (this.config.icons.length - 1))
				];
			// let item = new randomItem.IconClass(randomItem, true, false);
			let item = new randomItem.IconClass(randomItem, true, false, false, {
				col: this.id,
				row: i
			});
			this.rotateItems.push(item);
		}

		for (let i = 0; i < 30; i++) {
			let randomItem =
				this.config.icons[
					Math.floor(Math.random() * (this.config.icons.length - 1))
				];
			// let item = new randomItem.IconClass(randomItem, true, false, true);
			let item = new randomItem.IconClass(randomItem, true, false, true, {
				col: this.id,
				row: i
			});

			this.rotateBaitItems.push(item);
		}
		if (this.config.reelMask) {
			if (this.maskGraphics !== null) {
				this.removeChild(this.maskGraphics);
			}
			this.maskGraphics = this.config.reelMask(
				50,
				100,
				this.config.iconWidth - this.config.iconGap,
				this.config.height * this.config.iconHeight
			);
			this.addChild(this.maskGraphics);
			this.mask = this.maskGraphics;
		}
	}

	start(delay) {
		this.isBonus = false;
		this.finished = false;
		this.stopMode = Reel.STOP_SIMPLE;
		this.stopItems = [];
		this.nextItems = [];
		new Tween(this.holder)
			.to({ y: window.isDesktop ? -50 : -20 }, 500)
			.easing(Easing.Back.InOut)
			.delay(delay)
			.onComplete(() => {
				this.mask = this.maskGraphics;
				this.maskGraphics.alpha = 1;
				this.nextFloor();
			})
			.start();
	}

	replaceWilds(wilds) {
		for (let i = 0; i < wilds.length; i++) {
			if (wilds[i] !== null) {
				this.items[i].alpha = 0;
				this.items[i] = wilds[i];
				this.items[i].alpha = 1;
			}
		}
	}

	restoreWilds() {
		for (let i = 0; i < this.items.length; i++) {
			this.holder.addChild(this.items[i]);
			this.items[i].alpha = 1;
			this.items[i].x = 0;
		}
	}

	getFreeItem() {
		var arr = this.rotateItems;
		if (this.stopMode === Reel.STOP_BAIT) {
			arr = this.rotateBaitItems;
		}
		for (let i = 0; i < arr.length; i++) {
			const element = arr[i];
			if (!element.parent) {
				return element;
			}
		}
		let randomItemData =
			this.config.icons[
				Math.floor(Math.random() * (this.config.icons.length - 1))
			];
		let randomItem = new randomItemData.IconClass(randomItemData, true, false);
		arr.push(randomItem);
		return randomItem;
	}

	fastStop() {
		this.currentFloor = 1000;
		this.stopMode = Reel.STOP_FAST;
		this.stopItems = this.nextItems;
	}
	timeouts = [];

	stop(items, time, _stopMode, isBonus) {
		while (this.timeouts.length > 0) {
			clearTimeout(this.timeouts.pop());
		}

		this.nextItems = items;
		this.isBonus = isBonus;
		var timeout = 300 * this.id + time;
		this.stopMode = _stopMode;
		if (this.stopMode === Reel.STOP_FAST) {
			this.currentFloor = 1000;
			this.stopItems = items;
			return;
		}
		this.timeouts.push(
			setTimeout(() => {
				this.stopItems = this.nextItems;
			}, timeout)
		);
	}

	nextFloor() {
		this.currentFloor++;
		if (this.finished) {
			if (GameConfigs.betReels) {
				if (
					this.stopItemsOld[0] !== GameConfigs.betReels[this.id][0] ||
					this.stopItemsOld[1] !== GameConfigs.betReels[this.id][1] ||
					this.stopItemsOld[2] !== GameConfigs.betReels[this.id][2]
				) {
					logger.log(
						`%cREELS_STOP_BUG: ${this.id}, ${this.stopItemsOld}, ${GameConfigs.betReels[this.id]}`,
						'color: red; background: black; padding: 10px'
					);
				}
			}
			if (this.stopMode !== Reel.STOP_BAIT) {
				window.sm.play({ name: 'reel_finish_sfx' });
			}
			// if (this.id < 4) {
			//   for (let index = 0; index < this.stopItems.length; index++) {
			//     if (this.stopItems[index] === Reel.ScatterCode) {
			//       window.sm.play({ name: "scatter_appear_sfx" });
			//       // break;
			//     }
			//   }
			// }
			return;
		}
		this.items = [];
		this.finished = this.stopItems.length > 0 && this.currentFloor > 3;

		for (let i = 0; i < this.config.height; i++) {
			var item = null;
			if (this.stopItems.length > 0) {
				let randomItem = this.config.icons[this.stopItems[i]];
				if (this.isBonus && randomItem.isWild) {
					randomItem.iconBg = randomItem.iconBgBonus;
				} else if (randomItem.isWild) {
					randomItem.iconBg = randomItem.iconBgRotate;
				}
				item = new randomItem.IconClass(randomItem, false, false, false, {
					col: this.id,
					row: i
				});

				if (this.stopItems[i] === 10 && this.finished) {
					logger.log(
						'play scater appear',
						this.stopItems[i],
						item.item.id,
						this.finished
					);
					window.sm.play({ name: 'scatter_appear_sfx' });
				}
			} else {
				item = this.getFreeItem();
			}

			this.items.push(item);

			item.y =
				-this.config.iconHeight * this.config.height +
				this.config.iconHeight * i;
			item.yOrigin = this.config.iconHeight * i;
			this.holder.addChild(item);
		}

		if (this.finished) {
			this.stopItemsOld = this.stopItems;
			this.stopItems = [];
			this.nextItems = [];
		}

		for (let t = this.items.length - 1; t >= 0; t--) {
			if (this.finished) {
				if (this.isBonus && this.items[t].item.isWild) {
					//this.items[t].showBG(180 + t * 100, 300, 1);
				} else {
					this.items[t].showBG(180 + t * 100, 300, 1);
				}
			}
		}
		//this.stopMode
		let time = 100;
		let tweenType = Easing.Linear.None;
		if (this.finished) {
			time = 500;
			if (this.stopMode === Reel.STOP_SIMPLE) {
				tweenType = Easing.Back.Out;
			}
			if (this.stopMode === Reel.STOP_BAIT) {
				tweenType = Easing.Quintic.Out;
				time = 1600;
			}
			if (this.stopMode === Reel.STOP_FAST) {
				tweenType = Easing.Quintic.Out;
				time = 150 * this.id;
			}
		}
		new Tween(this.holder)
			.to({ y: this.config.iconHeight * this.config.height }, time)
			.easing(tweenType)
			.onComplete(() => {
				while (this.holder.children[0]) {
					this.holder.removeChild(this.holder.children[0]);
				}
				this.holder.y = 0;
				for (let t = 0; t < this.items.length; t++) {
					this.items[t].y = this.items[t].yOrigin;
					this.holder.addChild(this.items[t]);
				}
				setTimeout(() => {
					this.mask = this.maskGraphics;
					this.maskGraphics.alpha = 1;
					this.nextFloor();
				}, 0);
				if (this.finished) {
					this.mask = null;
					this.maskGraphics.alpha = 0;
					this.currentFloor = 0;
					if (this.reelHandler) {
						// console.log('cdnkjnckjadnckjanckla', this.id, this)
						this.reelHandler({ id: this.id, type: Reel.FINISHED });
					}
				}
			})
			.start();
	}

	animateLoopItems(ids) {
		for (let t = 0; t < this.items.length; t++) {
			if (ids.indexOf(this.items[t].item.id) >= 0) {
				this.items[t].animateLoop();
			}
		}
	}
	stopLoopItems() {
		window.sm.stop('reel_rolling', 100);
		for (let t = 0; t < this.items.length; t++) {
			this.items[t].stopLoop();
		}
	}
}

export default Reel;
